export default __webpack_public_path__ + "static/media/arrow-down.1834c23f.svg";